import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionAttachment } from "models";

type ConnectInterventionPayload = {
  intervention_id: number;
  question_result_id?: number;
  question_result_status?: number;
};

export const useConnectInterventionMutation = () =>
  useTypedMutation<ConnectInterventionPayload, InterventionAttachment[]>({
    mutationFn: async payload => {
      const data = await ApiInstance.post("/interventions/link", payload);
      return data.attachments || [];
    },
    onSuccess: ({ intervention_id, question_result_id, question_result_status }, attachments) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length) return;

      const interventionIdx = appointment.interventions.findIndex(intervention => intervention.id === intervention_id);
      if (interventionIdx < 0) return;

      const intervention = appointment.interventions[interventionIdx];
      const connection = question_result_id && question_result_status ? { question_result_id, question_result_status } : {};

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, {
          ...intervention,
          ...connection,
          attachments: intervention.attachments?.concat(attachments) ?? attachments
        })
      });
    }
  });
